import { render } from "./HeroiconsOutlineArrowDown.vue?vue&type=template&id=7d30a8e6"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowDown.vue"]])

export default __exports__